import { MODERN_THEMES } from 'foundations-theming-base/modern-themes';
import { getHostname } from './utils';
const MODERN_THEME_NAMES = Object.values(MODERN_THEMES).map(({
  themeName
}) => themeName);
function validateThemeParams(themeParams) {
  const {
    themeName,
    themeMode
  } = themeParams;
  if (!['canvas', 'trellis', ...MODERN_THEME_NAMES].includes(themeName)) {
    throw new Error(`Invalid theme name: ${themeName}`);
  }
  if (!['light', 'dark'].includes(themeMode)) {
    throw new Error(`Invalid theme mode: ${themeMode}`);
  }
  if (themeName === 'canvas' && themeMode === 'dark') {
    throw new Error(`Canvas theme does not support dark mode`);
  }
  if (MODERN_THEME_NAMES.includes(themeName) && !(`${themeName}-${themeMode}` in MODERN_THEMES)) {
    throw new Error(`${themeName} theme does not support ${themeMode} mode`);
  }
}

// id rather not add an enviro dep, so get the hublet manually
export function getUrlDetails(themeVersion) {
  const regexp = /^(?:app|local)(?:-([a-z]+[0-9]))?.hubspot(qa)?\.com/;
  const baseUrl = getHostname();
  const match = baseUrl.match(regexp);
  if (!match) {
    return {
      hublet: '',
      suffix: ''
    };
  }
  const hublet = match[1] || '';
  let suffix = match[2] || '';
  if (themeVersion.type === 'deployed') {
    suffix = (themeVersion === null || themeVersion === void 0 ? void 0 : themeVersion.env) === 'qa' ? 'qa' : '';
  }
  return {
    hublet,
    suffix
  };
}
const getDeployedThemeUrl = themeVersion => {
  const {
    hublet,
    suffix
  } = getUrlDetails(themeVersion);
  if (themeVersion.type === 'default') {
    throw new Error(`${themeVersion.type} themes do not have deployed URLs.`);
  }
  if (themeVersion.type === 'version') {
    return `https://static.hsappstatic.net/foundations-theming-base/static-${themeVersion.version}/bundles/multi-theme-${themeVersion.channel}.js`;
  }
  const subdomain = themeVersion.type === 'local' ? `local${hublet}` : `app${hublet}`;
  return `https://${subdomain}.hubspot${suffix}.com/foundations-theming-base/theme-${themeVersion.channel}.js`;
};
export const getDeployedTheme = async themeSettings => {
  validateThemeParams(themeSettings);
  const {
    themeName,
    themeMode,
    themeVersion
  } = themeSettings;
  const chosenTheme = `${themeName}-${themeMode}`;
  const themeUrl = getDeployedThemeUrl(themeVersion);
  const deployedTheme = await import( /* webpackIgnore: true */themeUrl).then(m => m.default).catch(err => {
    throw new Error(`Failed to load theme from ${themeUrl}: ${err.message}`);
  });
  const theme = deployedTheme[chosenTheme];
  if (!theme) {
    throw new Error('Unsupported theme name and mode combination.');
  }
  return theme;
};